export default function({ store, route, redirect }) {
  if (process.client && !store.getters['user/token']) {
    if (route.fullPath !== '/') return redirect('/');
  }
}
